import { ContentInstructions, CoreContents, FromSettingsInstruction } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type KpiTrendsOptions = {
  data?: DataOptionsFactory;
  grouping: string | FromSettingsInstruction;
  kpis: string[] | FromSettingsInstruction;
};

export class KpiTrendsFactory extends ContentFactory {
  constructor(options: KpiTrendsOptions) {
    const { grouping, kpis, data } = options;

    const instructions: ContentInstructions = {
      grouping:
        typeof grouping === 'string'
          ? {
              type: 'StringInstruction',
              instruction: grouping,
            }
          : grouping,
      kpis: Array.isArray(kpis)
        ? {
            type: 'StringListInstruction',
            instruction: kpis,
          }
        : kpis,
    };

    super(CoreContents.kpiTrends, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
